import {
    AtIcon,
    Button,
    Flex,
    HashtagIcon,
    IconButton,
    SendIcon,
} from '@adamdotai/design-system'
import { INSERT_AT_MENTION } from '@adamdotai/editor/AtMentionsPlugin'
import { INSERT_HASHTAG_MENTION } from '@adamdotai/editor/HashtagMentionsPlugin'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useTranslations } from 'next-intl'
import React from 'react'
import { SUBMIT_VALUE_COMMAND } from './SendMessagePluginCommands'

const RichTextInputActionsArea = ({
    readOnly,
    onCancel,
    shouldHidePersonPlugin,
    shouldHideHashtagPlugin,
    submitButtonTestId,
    actionAreaProps,
}) => {
    const [editor] = useLexicalComposerContext()

    const intialState = React.useMemo(() => editor.getEditorState(), [])

    const submitComment = () => {
        editor.focus()
        editor.dispatchCommand(SUBMIT_VALUE_COMMAND, undefined)
    }

    const handleMentionUser = () => {
        editor.focus()
        editor.dispatchCommand(INSERT_AT_MENTION, undefined)
    }

    const handleMentionContent = () => {
        editor.focus()
        editor.dispatchCommand(INSERT_HASHTAG_MENTION, undefined)
    }

    const handleCancelCommand = () => {
        onCancel(editor, intialState)
    }
    const t = useTranslations()
    return (
        <Flex
            justifyContent="space-between"
            alignItems="center"
            pt="2"
            dir="ltr"
            {...actionAreaProps}
        >
            <Flex>
                {!shouldHidePersonPlugin && (
                    <IconButton
                        tooltipProps={{
                            label: '',
                        }}
                        onClick={handleMentionUser}
                    >
                        <AtIcon />
                    </IconButton>
                )}

                {!shouldHideHashtagPlugin && (
                    <IconButton
                        tooltipProps={{
                            label: '',
                        }}
                        onClick={handleMentionContent}
                    >
                        <HashtagIcon />
                    </IconButton>
                )}
            </Flex>
            {readOnly ? (
                <Flex gap="2" pe="2">
                    <Button
                        size="xs"
                        variant="outline"
                        onClick={handleCancelCommand}
                    >
                        {t('common.cancel')}
                    </Button>

                    <Button size="xs" onClick={submitComment}>
                        {t('common.save')}
                    </Button>
                </Flex>
            ) : (
                <IconButton
                    aria-label=""
                    tooltipProps={{ label: '' }}
                    onClick={submitComment}
                    color="netural"
                    {...(submitButtonTestId && {
                        'data-testid': submitButtonTestId,
                    })}
                >
                    <SendIcon />
                </IconButton>
            )}
        </Flex>
    )
}

export { RichTextInputActionsArea }
